export default __webpack_public_path__ + "static/media/754.40866ad7.png";